import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./styles/index.css";

// React 18 concurrent root — required for Suspense / lazy loading we'll
// introduce in later phases.
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
